var exports = {
  "kL": "xa15a2ab7--2ae610--container",
  "DD": "xa15a2ab7--2ae610--title",
  "Qq": "xa15a2ab7--2ae610--text",
};

module.exports = exports;
